import React from "react"

import { Box } from "components/shared/box"
import { Button } from "components/shared/landing/button"
import { ModalWrapper } from "components/shared/modal-wrapper"
import { Text } from "components/shared/text"

type TypeAlert = "info" | "success" | "warning" | "error"

type InfoModalProps = {
  close: () => void
  onConfirm?: () => void
  type?: TypeAlert
  title?: React.ReactNode
  okButtonText?: string
  showCancelButton?: boolean
  cancelButtonText?: string
  message?: React.ReactNode
  children?: React.ReactNode
}

export function InfoModal({
  close,
  onConfirm,
  title,
  message,
  children,
  okButtonText = "Got it",
  cancelButtonText = "Cancel",
  showCancelButton,
}: InfoModalProps) {
  return (
    <ModalWrapper close={close} title={title} showClose={false}>
      <Text as="p" className="text-h3-modal mb-8 text-center ">
        {message}
      </Text>
      {children}
      <Box center row className="w-full gap-4">
        {showCancelButton && (
          <Button type="secondary" className="w-full md:w-auto" onClick={close}>
            {cancelButtonText}
          </Button>
        )}
        <Button className="w-full md:w-auto" onClick={onConfirm ?? close}>
          {okButtonText}
        </Button>
      </Box>
    </ModalWrapper>
  )
}
